import { FlowType } from '@jerry-serverless/types';

import type { Step } from '../types/step';
import { type AppData } from '../../types/app_data';
import { MiddleNameStep } from '../create_account/middlename.step';
import { ConfirmMiddleNameStep } from '../create_account/confirmmiddlename.step';

import { AddCarYearStep } from './addcaryear.step';
import { AddCarOnboardingSteps } from './addcars.step';
import { CarsStep } from './cars.step';
import { DriversStep } from './drivers.step';
import { AddDriverStep } from './adddriver';
import { AddDriverSelectNameStep } from './adddriverselectname';
import { AddDriverEnterNameStep } from './adddriverentername';
import { OccupationStep } from './occupation.step';
import { OccupationDriverStep } from './occupationDriver.step';
import { OccupationListStep } from './occupationList.step';
import { OccupationListDriverStep } from './occupationListDriver.step';
import { EducationStep } from './education.step';
import { EmailStep } from './email.step';
import { PrefillAdditionalInfoStep } from './prefilladditionalinfo.step';
import { EstimatedMileageStep } from './estimatedmileage';
import { RefiCarsAfterUpdatePolicyInfoStep } from './reficars.afterupdatepolicyinfo.step';
import { NNOOnboardingSteps } from './nnoPrompt.step';
import { ViolationsCountOnboardingStep } from './violationcount.step';
import { FinancedCarsStep } from './financedcars.step';
import { SelectFinancedCarsStep } from './selectfinancedcars.step';
import { DoBStep } from './dob.step';
import { AddressStep } from './address.step';
import { SkipLNStep } from './skipLN.step';
import { LoadingStep } from './loading.step';
import { InsuredOnboardingStep } from './insured.step';
import { NotInsuredOnboardingStep } from './notinsured.step';
import { DescribeAddressStep } from './describeaddress.step';
import { AnotherAddressStep } from './anotheraddress.step';
import { InsuredHistoryOnboardingStep } from './insuredhistory.step';
import { DriverViolationsStep } from './driverviolations.step';
import { AddMaintenanceReminderSteps } from './addmaintenance.step';
import { AddMaintenanceReminderAfterGarageSteps } from './addmaintenance.aftergarage.step';
import { DwepStep } from './dwep.step';
import { GarageStep } from './garage.step';
import { ClaimsOnboardingStep } from './claims.step';
import { HomeOwnerStep } from './homeowner.step';
import { DiscountsStep } from './discounts.step';
import { ReferralStep } from './referral.step';
import { DriverLicenseStep } from './driverlicense.step';
import { MaritalStatusStep } from './marital.step';
import { SelectPartnerOnboardingStep } from './selectpartner.step';
import { CreditRangeStep } from './creditrange.step';
import { PremiumStep } from './premium.step';
import { RefiCarsStep } from './reficars.step';
import { MinNumberPaymentsStep } from './minnumberpayments.step';
import { IncomeStep } from './income.step';
import { RefiOfferStep } from './refioffer.step';
import { BundleOptInStep } from './bundleoptin.step';
import { CoverageOnboardingStep } from './coverage.step';
import { FullCoverageStep } from './fullcoverage.step';
import { CarsLoadingStep } from './carsloading.step';

export const getOnboardingSteps = (flowType?: AppData['flowType']): Step[] => {
  const defaultSteps: Step[] = [
    PrefillAdditionalInfoStep,
    MiddleNameStep,
    ConfirmMiddleNameStep,
    DoBStep,
    AddressStep,
    DescribeAddressStep,
    AnotherAddressStep,
    SkipLNStep,
    LoadingStep,

    InsuredOnboardingStep,
    NotInsuredOnboardingStep,
    InsuredHistoryOnboardingStep,
    CoverageOnboardingStep,
    ClaimsOnboardingStep,
    ViolationsCountOnboardingStep,
    HomeOwnerStep,
    CreditRangeStep,

    AddCarYearStep,
    ...AddCarOnboardingSteps,
    CarsStep,
    ...NNOOnboardingSteps,
    FinancedCarsStep,
    SelectFinancedCarsStep,
    CarsLoadingStep,
    FullCoverageStep,
    RefiCarsStep,
    ...AddMaintenanceReminderSteps,

    DriversStep,
    AddDriverStep,
    AddDriverSelectNameStep,
    AddDriverEnterNameStep,
    MaritalStatusStep,
    SelectPartnerOnboardingStep,
    DriverViolationsStep,

    OccupationStep,
    OccupationDriverStep,
    OccupationListStep,
    OccupationListDriverStep,
    EducationStep,

    RefiOfferStep,
    RefiCarsAfterUpdatePolicyInfoStep,
    MinNumberPaymentsStep,
    EstimatedMileageStep,
    IncomeStep,
    DwepStep,
    GarageStep,
    ...AddMaintenanceReminderAfterGarageSteps,
    BundleOptInStep,
    DiscountsStep,
    ReferralStep,
    EmailStep,
    // Be careful adding step here, cause user can skip later steps after discounts or referral
    DriverLicenseStep,
    PremiumStep,
  ];

  const repairEstimateFlowSteps: Step[] = [];
  let steps = defaultSteps;
  if (flowType === FlowType.RepairEstimate) {
    steps = repairEstimateFlowSteps;
  }
  if (flowType === FlowType.Maintenance) {
    steps = [EmailStep];
  }
  return steps;
};
